function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35 14C27.3 14 21 20.3 21 28C21 35.7 27.3 42 35 42C42.7 42 49 35.7 49 28C49 20.3 42.7 14 35 14ZM35 35C31.15 35 28 31.85 28 28C28 24.15 31.15 21 35 21C38.85 21 42 24.15 42 28C42 31.85 38.85 35 35 35ZM80.15 74.2L65.8 59.85C67.2 56.35 66.5 51.8 63.35 49C60.2 45.85 55.65 45.15 51.8 46.9L58.45 53.55L53.55 58.45L46.55 51.45C44.8 55.3 45.5 59.85 48.65 63.35C51.8 66.5 56 67.2 59.5 65.8L73.85 80.15C74.55 80.85 75.6 80.85 75.95 80.15L79.45 76.65C80.5 75.6 80.5 74.55 80.15 74.2V74.2ZM31.85 52.5C31.5 53.55 31.5 54.95 31.5 56C31.5 58.45 31.85 60.9 32.55 63H14V59.5C14 57.75 20.3 53.2 31.85 52.5ZM35 45.5C19.6 45.5 7 51.8 7 59.5V70H45.5C41.3 66.85 38.5 61.6 38.5 56C38.5 52.15 39.55 48.65 41.65 45.85C39.55 45.85 37.45 45.5 35 45.5Z",
  fill: "#666666"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1648 74.0541L65.5669 59.4562C67.0106 55.7666 66.2085 51.4353 63.1606 48.3874C59.9523 45.1791 55.1398 44.5374 51.2898 46.302L58.1877 53.1999L53.3752 58.0124L46.3169 51.1145C44.3919 54.9645 45.194 59.777 48.4023 62.9853C51.4502 66.0332 55.7815 66.8353 59.471 65.3916L74.069 79.9895C74.7106 80.6312 75.6731 80.6312 76.3148 79.9895L80.0044 76.2999C80.8065 75.6582 80.8065 74.5353 80.1648 74.0541Z",
  fill: "#FF6600"
});

function SvgService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.1783158f.svg";
export { ForwardRef as ReactComponent };